<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input clearable v-model="listQuery.name" :placeholder="$t('user.sectionName')" style="width: 200px;" class="filter-item" @keyup.enter.native="handleFilter" />
      <el-button v-waves class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">
        {{ $t('table.search') }}
      </el-button>
      <el-button class="filter-item" style="margin-left: 10px;" type="primary" icon="el-icon-edit" @click="handleCreate">
        {{ $t('table.add') }}
      </el-button>
    </div>

    <el-table
      :key="tableKey"
      v-loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%;"
      @sort-change="sortChange"
    >
      <el-table-column :label="$t('table.id')" prop="id" sortable="custom" align="center" width="100px">
      </el-table-column>
      <el-table-column :label="$t('user.sectionName')" prop="name" align="center">
      </el-table-column>
      <el-table-column :label="$t('table.status')" prop="status" align="center" width="100px">
        <template slot-scope="scope">
          <el-button type="success" size="mini" plain v-if="scope.row.status === 1">正常</el-button>
          <el-button type="danger" size="mini" plain v-else>禁用</el-button>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('table.createdAt')"
        prop="created_at"
        width="170"
        align="center">
      </el-table-column>
      <el-table-column
        :label="$t('table.updatedAt')"
        prop="updated_at"
        width="170"
        align="center">
      </el-table-column>
      <el-table-column :label="$t('table.actions')" fixed="right" align="center" width="230" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleUpdate(scope.row)">
            {{ $t('table.edit') }}
          </el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)">
            {{ $t('table.delete') }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" />

    <el-dialog :title="textMap" :visible.sync="dialogFormVisible">
      <el-form @submit.native.prevent ref="dataForm" :rules="rules" :model="temp" label-position="right" :label-width="formLabelWidth" v-loading="dialogFormLoading">
        <el-form-item :label="$t('user.sectionName')" prop="name">
          <el-input v-model="temp.name" />
        </el-form-item>
        <el-form-item :label="$t('table.status')">
          <el-switch
            v-model="temp.status"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="1"
            :inactive-value="2">
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">
          {{ $t('table.cancel') }}
        </el-button>
        <el-button type="primary" @click="dialogStatus==='create'?createData():updateData()">
          {{ $t('table.confirm') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { fetchList, fetchDetail, create, update, del } from '@/api/section'
import waves from '@/directive/waves' // Waves directive
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination

export default {
  name: 'SystemSetting',
  components: { Pagination },
  directives: { waves },
  data() {
    var validateName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('user.sectionNameRequired')))
      } else {
        callback()
      }
    }
    return {
      tableKey: 0,
      list: [],
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        name: undefined,
        id_sort: 'desc'
      },
      temp: {
        id: undefined,
        name: '',
        status: 1
      },
      dialogFormVisible: false,
      dialogStatus: '',
      rules: {
        name: [{ required: true, validator: validateName, trigger: 'blur' }]
      },
      dialogFormLoading: false
    }
  },
  computed: {
    formLabelWidth: function() {
      return this.$store.getters.language === 'zh' ? '100px' : '200px'
    },
    textMap: function() {
      return this.dialogStatus === 'update' ? this.$t('form.edit') : this.$t('form.create')
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.listLoading = true
      fetchList(this.listQuery).then(response => {
        this.list = response.data.list
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    sortChange(data) {
      const { prop, order } = data
      if (prop === 'id') {
        this.sortByID(order)
      }
    },
    sortByID(order) {
      if (order === 'ascending') {
        this.listQuery.id_sort = 'asc'
      } else {
        this.listQuery.id_sort = 'desc'
      }
      this.handleFilter()
    },
    resetTemp() {
      this.temp = {
        id: undefined,
        name: '',
        status: 1
      }
    },
    handleCreate() {
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    createData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          create(this.temp).then((res) => {
            if (res.code === 20000) {
              this.dialogFormVisible = false
              this.$message.success(this.$t('form.createSuccess'))
              this.handleFilter()
            }
          })
        }
      })
    },
    handleUpdate(row) {
      this.dialogFormLoading = true
      this.resetTemp()
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
      fetchDetail(row.id).then((res) => {
        this.temp = {
          id: res.data.detail.id,
          name: res.data.detail.name,
          status: res.data.detail.status
        }
        this.dialogFormLoading = false
      })
    },
    updateData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          update(this.temp).then(() => {
            this.dialogFormVisible = false
            this.$message.success(this.$t('form.updateSuccess'))
            this.handleFilter()
          })
        }
      })
    },
    handleDelete(row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        del({ id: row.id }).then((res) => {
          if (res.code === 20000) {
            this.$message.success(this.$t('form.delSuccess'))
            this.handleFilter()
          }
        })
      }).catch(() => {
      })
    }
  }
}
</script>
